import React from "react";
import { StaticQuery, graphql } from "gatsby";

import { About } from "../page-components";

function AboutPage(props) {
  return (
    <StaticQuery
      query={aboutPageQuery}
      render={(data) => <About {...props} {...data} />}
    />
  );
}

export default AboutPage;

const aboutPageQuery = graphql`
  query AboutQuery {
    markdownRemark(frontmatter: { templateKey: { eq: "about" } }) {
      frontmatter {
        seoTitle
        bannerImage {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        phoneMockup {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        heading
        subheadings
        valueProps {
          heading
          body
          image {
            src {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            alt
          }
        }
      }
    }
    bannerImage: file(relativePath: { eq: "about-page/concert-banner.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    phoneMockup: file(relativePath: { eq: "about-page/phone-mockup.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;
